import React from "react";

function SvgIcMapPoi013(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M16.969 15.985h3.986v-3.986h-3.986v3.986zm-5.98 0h3.987v-3.986H10.99v3.986zm0 6.974h3.987v-3.985H10.99v3.985zm5.039-13.932V5L8 9.027V26h8.969v-7.026h3.986V26H24V5l-7.972 4.027z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi013;
